import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import HospitalContactRecordDrawer from './HospitalContactRecordDrawer';

export const ManageHospitalContacts = ({
  hospital,
  contacts = [],
  updateHospitalContact,
  addHospitalContact,
  removeHospitalContact,
  setContactsUnderEdit = () => {},
}) => {
  const [addingContact, setAddingContact] = useState(false);
  const [formsUnderEdit, setFormsUnderEdit] = useState([]);

  const toggleFormUnderEdit = useCallback((formId) => {
    setFormsUnderEdit((prevForms) => (prevForms.includes(formId) ? [...prevForms.filter((f) => f !== formId)] : [...prevForms, formId]));
  }, []);

  useEffect(() => {
    setContactsUnderEdit(formsUnderEdit.length === 0);
  }, [formsUnderEdit, setContactsUnderEdit]);

  return (
    <Row>
      <Col>
        <div className="crud__section mb-3">
          <div className="crud__section-icon">
            <i className="fas fa-address-book" />
          </div>
          <h2 className="crud__section-header">Hospital Contact Records</h2>
          <p>
            Manage contact records for <strong>{hospital.name}</strong>. These contacts are specific to hospital communications and have different notification
            rules than invoice contacts.
          </p>

          {contacts.map((contact) => (
            <HospitalContactRecordDrawer
              isNew={contact.id === -1}
              hospital={hospital}
              canRemove={contacts.length > 1}
              toggleFormUnderEdit={toggleFormUnderEdit}
              key={contact.name + (contact.id ?? '-1')}
              contact={contact}
              onSubmit={(c) => updateHospitalContact(c, contact)}
              startOpen={contact.id === -1}
              onRemove={(c) => removeHospitalContact(c)}
            />
          ))}

          {!addingContact ? (
            <button className={'btn btn-outline-primary'} type={'button'} onClick={() => setAddingContact(true)}>
              <i className="fas fa-plus mr-2" />
              Add Hospital Contact
            </button>
          ) : (
            <>
              <HospitalContactRecordDrawer
                hospital={hospital}
                canRemove={false}
                toggleFormUnderEdit={toggleFormUnderEdit}
                isNew={true}
                contact={{
                  notifyByMobile: false, // Always false for hospital contacts
                  notifyByEmail: true,
                  isInitialInvoice: false,
                  isChaseToContact: false,
                  isDisabled: false, // Default enabled for new contacts
                }}
                startOpen={true}
                onSubmit={(c) => {
                  const added = addHospitalContact(c);
                  setAddingContact(false);
                  return added;
                }}
              />

              <button className={'btn btn-danger'} type={'button'} onClick={() => setAddingContact(false)}>
                Cancel adding contact
              </button>
            </>
          )}
        </div>
      </Col>
    </Row>
  );
};
